<template>
  <v-dialog v-model="cupomDetalhesModal" scrollable persistent full-width max-width='933'>
    <v-card>
      <v-card-title>
        <v-flex>
          <span class="titulo-detalhes pl-4  mt-2 mb-2 headline">{{cupom.id === 0 ? 'Novo cupom de desconto' : cupom.name }}</span>
        </v-flex>
        <v-spacer></v-spacer>
        <v-flex class="text-xs-right">
          <v-btn icon @click.native="close()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-flex>
      </v-card-title>
        <v-card-text class="pa-0">
          <v-form name="form-cadastro" ref="itemForm">
            <v-layout row wrap class="pl-5 pr-5 mt-3">
              <v-flex xs12 sm12 md12>
                <v-text-field
                name="nome"
                label="Nome"
                :rules="rules.name"
                :value="typeof cupom.name !== 'undefined' ? cupom.name : ''"
                @input="updateName"
                required
                >
                </v-text-field>                
              </v-flex>
            </v-layout>
            <v-layout row wrap class="pl-5 pr-5 mt-3">
              <v-flex xs11 sm3 md3>
                 <v-select
                  :rules="rules.type"
                  :value="cupom.type"      
                  v-model="cupom.type"                          
                  @input="updateType"
                  :items="listTypes"
                  label="Tipo"        
                  single-line
                  item-text="label"
                  item-value="value"     
                  required>
                </v-select>
              </v-flex>
              <v-flex xs1 sm1 md1 pt-4 pl-3>
                <v-tooltip right>
                  <v-icon class="ml-2 link" slot="activator" color="blue">help_outline</v-icon>
                  <span>Se o desconto em é em porcentagem ou valor fixo.</span>
                </v-tooltip>
              </v-flex>
              <v-flex xs12 sm4 md4>
                <span class="label-amount">Valor</span>
                <the-mask 
                  :rules="rules.amount"
                  @input="updateAmount" 
                  :value="cupom.amount"                      
                  :validation="true"
                  label="Valor"
                  :masked="false"
                  class="the-mask-money"
                  :mask="amountMask" 
                />
              </v-flex>
              <v-flex xs11 sm3 md3>
                <v-text-field
                label="Código"
                @input="updateCode"
                :value="cupom.code">
                </v-text-field>
              </v-flex>
              <v-flex xs1 sm1 md1 pt-4 pl-3>
                <v-tooltip right>
                  <v-icon class="ml-2 link" slot="activator" color="blue">help_outline</v-icon>
                  <span>Código para aplicação do desconto.</span>
                </v-tooltip>
              </v-flex>
              <v-flex xs12 sm6 md6 pr-2>
                <v-menu
                    lazy
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    full-width
                    :nudge-right="40"
                    max-width="290px"
                    min-width="290px"
                  >
                    <v-text-field
                    slot="activator"
                    label="Início"
                    v-model="validityStartLabel"
                    prepend-icon="event"
                    readonly
                    >
                    </v-text-field>
                    <v-date-picker
                    :value="validityStartPicker"
                    @input="updateValidityStart"
                    :first-day-of-week="1"
                    locale="pt-br"
                    no-title
                    scrollable
                    actions
                    >                     
                    </v-date-picker>
                </v-menu>
              </v-flex>
                <v-flex xs12 sm6 md6 pl-2>
                <v-menu
                lazy
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                full-width
                :nudge-right="40"
                max-width="290px"
                min-width="290px"
                >
                <v-text-field
                    slot="activator"
                    label="Fim"
                    v-model="validityEndLabel"
                    prepend-icon="event"
                    readonly
                ></v-text-field>
                <v-date-picker
                    :value="validityEndPicker"
                    @input="updateValidityEnd"
                    :first-day-of-week="1"
                    locale="pt-br"
                    no-title
                    scrollable
                    actions
                    >                  
                </v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs11 sm5 md5>
                 <v-select
                  :rules="rules.limitationType"
                  :value="cupom.limitationType"      
                  v-model="cupom.limitationType"                          
                  @input="updateLimitationType"
                  label="Limitação de uso"        
                  single-line
                  item-text="label"
                  item-value="value" 
                  :items="listLimitationTypes"
                  required>
                </v-select>
              </v-flex>
              <v-flex xs1 sm1 md1 pt-4 pl-3>
                <v-tooltip right>
                  <v-icon class="ml-2 link" slot="activator" color="blue">help_outline</v-icon>
                  <span>Escolha a limitação de uso do desconto.</span>
                </v-tooltip>
              </v-flex>
              <v-flex xs11 sm5 md5>
                <v-text-field
                    label="N vezes"
                    v-show="cupom.limitationType == 2 || cupom.limitationType == 3"
                    @input="updateLimitation"
                    :value="cupom.limitation">
                </v-text-field>
              </v-flex>
              <v-flex xs1 sm1 md1 pt-4 pl-3>
                <v-tooltip right v-show="cupom.limitationType == 2 || cupom.limitationType == 3"    >
                  <v-icon class="ml-2 link" slot="activator" color="blue">help_outline</v-icon>
                  <span>O número de vezes que o desconto pode ser utilizado.</span>
                </v-tooltip>
              </v-flex>
              <v-flex xs12 sm3 md3 pl-2>
                <p>Ativo</p>
                <SelectionBtn :value="cupom.active" @input="toggleActive"/>
              </v-flex>   
              <v-flex xs12 sm3 md3 pl-2>
                <p>Para todos os produtos?</p>
                <SelectionBtn :value="cupom.produtos" @input="toggleProdutos"/>
              </v-flex> 
              <v-flex xs12 sm6 md6 pl-2>
                <v-autocomplete
                    v-model="cupom.servicoProdutosList"
                    :items="listItens"
                    label="Produtos"
                    item-text="name"
                    item-value="id"
                    multiple
                    v-show="!cupom.produtos"
                    >
                </v-autocomplete>
              </v-flex>
              <v-flex xs11 sm11 md11 pl-2>
                <v-text-field
                  name="observation"
                  label="Observação"
                  :value="typeof cupom.observation !== 'undefined' ? cupom.observation : ''"
                  @keypress.enter.prevent
                  @input="updateObservation"
                  multi-line>
                </v-text-field>
              </v-flex> 
               <v-flex xs1 sm1 md1 pt-4 pl-3>
                <v-tooltip right>
                  <v-icon class="ml-2 link" slot="activator" color="blue">help_outline</v-icon>
                  <span> Alguma informação sobre o cupom, por exemplo, cupom válido somente para a região do Morumbi ou cupom válido somente para condomínios da administradora X.</span>
                </v-tooltip>
              </v-flex>  
            </v-layout> 
            
            <v-layout row wrap class="pl-5 pr-5 mt-3">
              <v-flex xs12 mt-3 class="text-xs-center">
                <v-spacer></v-spacer>
                <v-btn flat outline round color="green" class="mb-4" :disabled="loadingCupomAction" @click.native="updateCupom()"><v-icon left>done_all</v-icon>Gravar</v-btn>              
              </v-flex>
            </v-layout>
          <v-progress-linear class="loading-modal" v-if="loadingCupomAction" color="error" v-bind:indeterminate="true"></v-progress-linear>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import SelectionBtn from '@/components/SelectionBtn'
import moment from 'moment'
import {TheMask} from 'vue-the-mask'

export default {
  name: 'cupom-detalhes',
  components: {
    SelectionBtn,
    TheMask
  },
  data () {
    return {
      ativo: false,
      rules: {
        name: [
          (v) => v.length > 0 || 'Insira um nome'
        ],
        type: [
          (v) => v > 0 || 'Selecione o tipo'
        ],
        amount: [
          (v) => v.length > 0 || 'Insira o valor'
        ],
        limitationType: [
          (v) => v > 0 || 'Selecione a limitação de uso'
        ]
      },
      listTypes: [
        {
          label: 'Porcentagem',
          value: 1
        },
        {
          label: 'Valor',
          value: 2
        }
      ],
      listLimitationTypes: [
        {
          label: 'Ilimitado',
          value: 1
        },
        {
          label: 'Somente N vezes',
          value: 2
        },
        {
          label: 'N vezes por cliente',
          value: 3
        }
      ]
    }
  },
  created () {
  },
  methods: {
    updateCupom () {
      if (this.$refs.itemForm.validate()) {
        this.$store.dispatch('updateCupom')
      } else {
        this.$store.commit('toastr', {
          color: 'info',
          texto: 'Verifique os campos em vermelho'
        })
      }
    },
    toggleActive (value) {
      this.$store.commit('updateCupomActive', value)
    },
    updateName (value) {
      this.$store.commit('updateCupomName', value)
    },
    updateType (value) {
      this.$store.commit('updateCupomType', value)
    },
    updateAmount (value) {
      this.$store.commit('updateCupomAmount', value)
    },
    updateCode (value) {
      this.$store.commit('updateCupomCode', value)
    },
    updateLimitationType (value) {
      this.$store.commit('updateCupomLimitationType', value)
    },
    updateLimitation (value) {
      this.$store.commit('updateCupomLimitation', value)
    },
    updateObservation (value) {
      this.$store.commit('updateCupomObservation', value)
    },
    updateProducts (value) {
      this.$store.commit('updateCupomProducts', value)
    },
    close () {
      this.$store.commit('toggleCupomModal', false)
    },
    updateValidityStart (value) {
      if (moment(value).diff(moment(), 'days') < 0) {
        this.$store.commit('toastr', {
          color: 'info',
          texto: 'A data de inicio não pode estar no passado'
        })
        return
      }
      if (this.validityEndPicker !== null) {
        if (moment(value).diff(moment(this.cupom.validityEnd)) <= 0) {
          this.$store.commit('updateCupomStart', value)
        } else {
          this.$store.commit('toastr', {
            color: 'info',
            texto: 'A data de inicio não pode ser maior que a final'
          })
        }
      } else {
        this.$store.commit('updateCupomStart', value)
      }
    },
    updateValidityEnd (value) {
      if (moment(value).diff(moment(), 'days') < 0) {
        this.$store.commit('toastr', {
          color: 'info',
          texto: 'A data de fim não pode estar no passado'
        })
        return
      }
      if (this.validityStartPicker !== null) {
        if (moment(value).diff(moment(this.cupom.validityStart)) >= 0) {
          this.$store.commit('updateCupomEnd', value)
        } else {
          this.$store.commit('toastr', {
            color: 'info',
            texto: 'A data final não pode ser menor que o inicio'
          })
        }
      } else {
        this.$store.commit('updateCupomEnd', value)
      }
    },
    toggleProdutos () {
      this.$store.commit('toggleProdutos')
    }
  },
  computed: {
    amountMask () {
      if (this.cupom.type === 1) {
        return ['# %', '## %']
      }
      return ['R$ #,##', 'R$ ##,##', 'R$ ###,##']
    },
    cupom () {
      return this.$store.getters.selectedCupom
    },
    cupomDetalhesModal: {
      get () {
        return this.$store.getters.cupomVisible
      },
      set () {
        this.$store.commit('toggleCupomModal', false)
      }
    },
    listItens () {
      return this.$store.getters.registeredItems
    },
    validityEndPicker () {
      return this.cupom.end === null ? null : moment(this.cupom.end).format('YYYY-MM-DD')
    },
    validityStartPicker () {
      return this.cupom.start === null ? null : moment(this.cupom.start).format('YYYY-MM-DD') || null
    },
    validityEndLabel () {
      return this.cupom.end === null ? null : moment(this.cupom.end).format('DD-MM-YYYY')
    },
    validityStartLabel () {
      return this.cupom.start === null ? null : moment(this.cupom.start).format('DD-MM-YYYY') || null
    },
    loadingCupomAction () {
      return this.$store.getters.loadingCupomAction
    }
  }
}
</script>
<style>
.prefix.input-group--prefix:not(.input-group--focused):not(.input-group--dirty) label{
  left: 23px!important;
}
.item-box{
  border: 1px solid #bdbdbd;
  border-radius: 15px;
  float: left;
}
.outerDiv{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
}
/* ajustes */
.titulo-detalhes{
    color: #e62039;
    font-size: 21px;
}
.titulo-detalhes .headline{
  font-size: 25px;
}
.titulo-detalhes-categoria{
  font-size: 21px;
  padding-top: 17px;
  color: #707983
}
p{
color: #838789
}
.label-amount{font-size: 16px;line-height: 20px;height: 20px;color:rgba(0,0,0,0.54);display: block;}
.the-mask-money{line-height: 20px;padding: 4px 0;border-bottom: thin solid #999;width: 90%;outline: none;}
</style>



// WEBPACK FOOTER //
// cupomDetalhe.vue?950e0bd0